<template>
  <div>
    <!-- 提示弹窗 -->
    <van-dialog
      :value="isShowDialog"
      class="dialog"
      :show-confirm-button="false"
    >
      <div class="tip-container">
        <div class="close-icon">
          <van-icon
            name="cross"
            color="#999999"
            size="16px"
            @click="onCheckNextTimeButton"
          />
        </div>
        <div class="title">
          充电宝合作协议更新
        </div>

        <Copywrite class="mb52" />

        <div class="copywrite-text grey2 mb40">
          请您仔细阅读
          <span
            class="href-text"
            @click="toAgreementDetail"
          >《{{ agreementOnShowDescriptions.name }}》</span>
          ，点击“签署”即代表您确认签署并遵守《{{ agreementOnShowDescriptions.name }}》的相应内容。
        </div>

        <van-button
          round
          class="confirm-button"
          @click="onConfirmButton"
        >
          签署
        </van-button>
      </div>
    </van-dialog>

    <!-- 验证码弹窗 -->
    <van-dialog
      v-model="isShowVertifyCodeDialog"
      class="dialog vertify-dialog"
      :show-confirm-button="false"
    >
      <div class="tip-container">
        <div class="close-icon">
          <van-icon
            name="cross"
            color="#999999"
            size="16px"
            @click="exitVertifyCodeDialog"
          />
        </div>
        <div class="title mb24">
          输入验证码
        </div>
        <div class="copywrite-text mb40 message">
          已向实名手机号：{{ mobileNo }}（{{ realName }}）发送验证码
        </div>
        <div class="mb24">
          <InputField
            ref="inputField"
            @input-code="onInputCode"
          />
        </div>
        <div class="copywrite-text grey2 mb40">
          若手机号已更换，请联系业务员
        </div>
        <van-button
          round
          :disabled="vertifyCode.length !== 6"
          class="confirm-button mb0"
          @click="onVertifyCodeButton"
        >
          确定
        </van-button>
      </div>
    </van-dialog>

    <!-- 确认退出弹窗 -->
    <van-dialog
      v-model="isShowExitDialog"
      class="dialog"
      :show-confirm-button="false"
    >
      <div class="tip-container">
        <div class="title">
          温馨提示
        </div>

        <div class="copywrite-text mb40">
          {{ rejectTip }}
        </div>

        <div class="exit-button-group">
          <van-button
            v-if="agreementOnShowDescriptions.withPhoneCall"
            round
            class="exit-button"
            @click="onExitButton"
          >
            退出
          </van-button>
          <a
            v-if="agreementOnShowDescriptions.withPhoneCall"
            class="call-button"
            :href="`tel:${ linkPhone }`"
          >
            立即拨打
          </a>
          <van-button
            v-if="!agreementOnShowDescriptions.withPhoneCall"
            round
            class="known-button"
            @click="onExitButton"
          >
            我知道了
          </van-button>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import Dialog from 'vant/lib/dialog';
import Button from 'vant/lib/button';
import Icon from 'vant/lib/icon';
import InputField from '@/views/agreement/InputField';
import Copywrite from '@/views/agreement/Copywrite';
import tracker from '@/util/tracker';
import AgreementApi from '@/api/agreement';
import { transformNumberToStr } from '@/util/filter';
import STATUS from '@/constants/status';

import 'vant/lib/dialog/style';
import 'vant/lib/button/style';
import 'vant/lib/icon/style';

export default {
  name: 'AgreementModal',
  components: {
    [Dialog.Component.name]: Dialog.Component,
    [Button.name]: Button,
    [Icon.name]: Icon,
    InputField,
    Copywrite,
  },
  data() {
    return {
      isShowExitDialog: false,
      isShowVertifyCodeDialog: false,
      vertifyCode: '',
      linkPhone: 4000005658,
    };
  },
  computed: {
    ...mapGetters('partnerModule', [
      'id',
      'isNeedToCheckRenewCooperationAgreement',
      'isNeedToCheckSubjectChangeAgreement',
      'isNeedToCheckKaSupplementAgreement',
      'agreementOnShowId',
      'agreementOnShowDescriptions',
    ]),
    ...mapState(
      'partnerModule',
      ['mobileNo', 'realName', 'certification'],
    ),
    isShowDialog() {
      const isShowDialog = this.isNeedToCheckRenewCooperationAgreement || this.isNeedToCheckSubjectChangeAgreement || this.isNeedToCheckKaSupplementAgreement;
      if (isShowDialog) {
        tracker.sendPV(this.agreementOnShowDescriptions.pageViewCid);
      }
      return isShowDialog;
    },
    rejectTip() {
      if (this.agreementOnShowDescriptions.withPhoneCall) {
        return this.rejectTipWord || `您的建议是美团充电宝不断前进的动力!请您阅读和确认补充协议内容，若您对补充协议内容有任何疑问可联系充电宝业务人员或拨打服务电话：${this.linkPhone}。`;
      }
      return this.rejectTipWord || '您的建议是美团充电宝不断前进的动力!请您阅读和确认补充协议内容，若您对补充协议内容有任何疑问可联系充电宝业务人员。';
    },
  },
  methods: {
    ...mapActions('partnerModule', ['checkAgreementNextTime', 'signAgreementSuccess']),

    onCheckNextTimeButton() {
      this.sendEvent(this.agreementOnShowDescriptions.disagreeButtonBid);
      this.isShowExitDialog = true;
    },

    async onConfirmButton() {
      if (!this.certification) {
        this.$dialog.toast('未完成实名认证', {
          type: 'fail',
          className: 'agreement-toast',
        });
        return;
      }

      this.sendEvent(this.agreementOnShowDescriptions.agreeButtonBid);

      this.isShowVertifyCodeDialog = true;
      await this.$nextTick();
      this.$refs.inputField.sendMessage();
    },

    onExitButton() {
      this.sendEvent(this.agreementOnShowDescriptions.exitButtonBid);
      this.checkAgreementNextTime();
      this.isShowExitDialog = false;
    },

    async onVertifyCodeButton() {
      /*
       *  根据当前协议选择对应的签约方法
       *  在@/api/agreement 中添加方法
       *  在@/constants/agreement AGREEMENT_TYPE_DESC中signApiName字段维护/添加对应协议签约的方法
       */
      try {
        const signApiMethod = AgreementApi[this.agreementOnShowDescriptions.signApiName];
        const {
          respCode, code, data, error,
        } = await signApiMethod({
          partnerId: this.id.toString(),
          messageCode: this.vertifyCode,
        }) || {};
        const _responseCode = transformNumberToStr(respCode) || transformNumberToStr(code);

        if (Number(_responseCode) === STATUS.SUCCESS && data) {
          this.$dialog.toast('您已确认签署', {
            type: 'success',
            className: 'agreement-toast center',
          });
          this.onSignAgreementSuccess();
        } else {
          this.$refs.inputField.clearInput();
          const msg = (error && error.msg) || '验证码错误，请重新输入';
          this.$dialog.toast(msg, {
            type: 'fail',
            className: 'agreement-toast',
          });
        }
      } catch (e) {
        console.log(e);
        console.error(`AgreementApi中 ${this.agreementOnShowDescriptions.signApiName} api可能不存在`);
      }
    },

    onSignAgreementSuccess() {
      this.signAgreementSuccess();
      this.isShowVertifyCodeDialog = false;
    },

    onInputCode(code) {
      this.vertifyCode = code;
    },

    exitVertifyCodeDialog() {
      this.isShowVertifyCodeDialog = false;
    },

    toAgreementDetail() {
      this.sendEvent(this.agreementOnShowDescriptions.toAgreementBid);
      this.$router.push({
        name: this.agreementOnShowDescriptions.routerName,
        params: {
          typeId: this.agreementOnShowId,
        },
      });
    },

    sendEvent(bid) {
      const valLab = {
        custom: {
          partnerId: this.id,
          customerId: this.$store.state.billModule.customerId,
        },
      };
      tracker.sendEvent(bid, valLab);
    },
  },
};
</script>

<style lang="scss" scoped>
$black1: #1A1A1A;
$black2: #333;
$grey1: #666;
$grey2: #999;
$white2: #F5F5F5;
$blue: #0067FF;

.mb0 {
  margin-bottom: 0 !important;
}

.mb24 {
  margin-bottom: 0.24rem !important;
}

.mb52 {
  margin-bottom: 0.52rem !important;
}

.mb40 {
  margin-bottom: 0.4rem !important;
}

.href-text {
  color: $blue;
}

.dialog {
  width: 6.5rem;

  &.vertify-dialog {
    width: 5.4rem;
  }
}

.tip-container {
  padding: 0.48rem 0.4rem 0.4rem;

  .title {
    font-weight: 500;
    font-family: PingFangSC-Medium;
    font-size: 0.36rem;
    color: $black2;
    letter-spacing: 0;
    margin-bottom: 0.32rem;
  }

  .copywrite-text {
    font-weight: 400;
    font-family: PingFangSC-Regular;
    font-size: 0.24rem;
    color: $grey1;
    text-align: left;

    &.message {
      color: $black2;
    }

    &.grey2 {
      color: $grey2;
    }
  }

  .confirm-button {
    width: 100%;
    margin-bottom: 0.3rem;
    background: $black1;
    color: white;
    font-weight: 600;
    font-size: 0.24rem;
    height: 0.88rem;
    line-height: 0.84rem;
  }

  .cancel-button {
    font-size: 0.24rem;
    color: $grey1;
  }

  .close-icon {
    line-height: 0.16rem;
    text-align: end;
  }

  .exit-button-group {
    width: 100%;
    display: flex;

    .exit-button {
      color: $black2;
      background: $white2;
      width: calc(50% - 0.09rem);
      margin-right: 0.18rem;
    }

    .call-button {
      color: white;
      background: $black1;
      width: calc(50% - 0.09rem);
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 999px;
    }

    .known-button {
      width: 100%;
      color: white;
      background: $black1;
      font-size: 0.24rem;
      height: 0.88rem;
      line-height: 0.84rem;
    }
  }
}
</style>
